import {computed, Ref, toValue} from "vue";
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {birthdayGiftApi} from "@/container";

/**
 * The birthday gift a patient can still collect, if any.
 */
const useCustomerBirthdayVoucher = (customerId: Ref<number> | number) => {
    const id = computed(() => toValue(customerId));

    return useSwr(
        () => cacheKey(`customers/${id.value}/birthday-gift-voucher`),
        () => birthdayGiftApi().customerVoucher(id.value)
    );
};

export default useCustomerBirthdayVoucher;
